module.exports = __webpack_public_path__ + "img/no-image-2.91ecc796.png";